import { api } from "#app/http/api";
import { ExtendedClient } from "#modules/clients/infra/Client.dto";

export const fetchClient = async (id: string): Promise<ExtendedClient | null> => {
  const response = await api.clients.findOne.query({
    params: {
      id,
    },
  });

  if (response.status === 200) {
    return response.body;
  }

  return null;
};
